import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { IMAGES } from "@/data/content";
import { Reveal } from "@/components/shared/Reveal";

export const ClosingCTA = () => (
  <section data-testid="closing-cta-section" className="relative overflow-hidden py-32 lg:py-44">
    <img src={IMAGES.dubai} alt="" className="absolute inset-0 -z-20 h-full w-full object-cover opacity-30" loading="lazy" />
    <div className="absolute inset-0 -z-10 bg-gradient-to-b from-navy via-navy/80 to-navy" />
    <div className="grain absolute inset-0 -z-10" />
    <div className="wrap max-w-4xl">
      <Reveal>
        <div className="eyebrow">Let's talk</div>
        <h2 className="mt-5 text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">
          Have a transportation technology challenge?
          <span className="block text-gradient pb-1">Let's design the right solution for it.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">
          Whether you need fleet IoT, logistics automation, school transportation, CCTV, AI or a complete transportation technology architecture, Wexoz can help you evaluate, design and implement the right solution.
        </p>
      </Reveal>
      <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-4">
        <Link to="/contact" data-testid="closing-talk-to-expert-cta" className="btn-primary">Talk to an Expert <ArrowUpRight className="h-4 w-4" /></Link>
        <Link to="/contact" data-testid="closing-tell-us-cta" className="btn-ghost group">Tell Us What You Need <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>
      </Reveal>
    </div>
  </section>
);
